import axios from "axios";

axios.defaults.withCredentials = true;

// axios.get("/api/user/account/cooperation").then(t=>{
//   console.log('/api/user/account/cooperation', t)
// })

const state = {
  teamCooTempList: {
    data: [],
    total: 0, // 总数
    fetching: false
  }, // 与我协作模板列表
  inviteCode: "", //生成的邀请码
  removeCooperatorStateInfo: {
    code: 0,
    msg: ""
  }, // 移除协作项目中成员的返回信息
  joinCooDraftStateInfo: {
    code: 0,
    msg: ""
  }, // 邀请成员加入协作项目返回信息
  teamMembers: [], // 团队成员列表
  copeTemplateInfo: {}, // 复制模板返回状态码
  historyVersionList: [],
  cooperationType: -1, //-1普通用户；2设计师；4管理员；6创建者;
  cooperationDraft: null,
  showCooperationBtn : true,
  cooperationDraftOwnerId : "",
  privateDraft: true
};

const getters = {
  teamCooTempList: state => state.teamCooTempList,
  inviteCode: state => state.inviteCode,
  removeCooperatorStateInfo: state => state.removeCooperatorStateInfo,
  joinCooDraftStateInfo: state => state.joinCooDraftStateInfo,
  teamMembers: state => state.teamMembers,
  copeTemplateInfo: state => state.copeTemplateInfo,

  cooperationType: state => state.cooperationType,
  historyVersionList: state => state.historyVersionList,
  showCooperationBtn: state => state.showCooperationBtn,
  cooperationDraftOwnerId: state => state.cooperationDraftOwnerId,
  cooperationDraftId: state => (state.cooperationDraft || {}).id,
  IsPrivateDraft: state => state.privateDraft
};

const actions = {
  /**
   * 获取团队模板列表
   * @param {type} sOfPage 每页数量
   * @param {type} fPage 首页数量
   * @param {type} pIndex 页码
   * @param {type} sort 1：最新，2：修改时间
   * @param {type} type 1：团队模板，2：协同项目
   */
  async fetchTeamCooTempList({ commit }, params = {}) {
    commit("updateTempListFetching", true);
    let _url = "/api/user/account/cooperation/templateR?type=2";
    if (params.sort) {
      _url += "&sort=" + params.sort;
    }
    if (params.sOfPage) {
      _url += "&sOfPage=" + params.sOfPage;
    }
    if (params.fPage) {
      _url += "&fPage=" + params.fPage;
    }
    if (params.pIndex) {
      _url += "&pIndex=" + params.pIndex;
    }
    const { data } = await axios.get(_url);
    if (data.code === 200) {
      // 此处先过滤无效数据，需要后端处理！！！
      let _data = data.data.filter(item => {
        return item.shareDarftVersion !== null;
      });
      commit("setTeamCooTempList", { data: _data, total: data.total });
    }
    commit("updateTempListFetching", false);
  },
  /**
   * 生成团员邀请码
   * @param {type}
   */
  async fetchInviteCode({ commit }, params = {}) {
    const { data } = await axios.post(
      "/api/user/account/cooperation/inviteCode",
      params
    );
    if (data.code === 200) {
      commit("setInviteCode", data.data);
    }
  },
  /**
   * 编辑协作项目、团队模板复制
   * @param {type} userId 被邀请团员的用户id
   * @param {type} id 协作项目的id
   */
  async fetchCopeTemplate({ commit }, params = {}) {
    const { data } = await axios.post(
      "/api/user/account/cooperation/draft",
      params
    );
    commit("setCopeTemplateInfo", data);
  },

  /**
   * 邀请成员加入协作项目
   * @param {type} userId 被邀请团员的用户id
   * @param {type} id 协作项目的id
   */
  async fetchJoinCooDraft({ commit }, params = {}) {
    const { data } = await axios.post(
      "/api/user/account/cooperation/joinDraft",
      params
    );
    commit("setJoinCooDraftState", data);
  },
  /**
   * 获取成员列表
   */
  async fetchTeamMembers({ commit }) {
    const { data } = await axios.get(
      "/api/user/account/cooperation?sOfPage=99999&fPage=99999"
    );
    if (data.code === 200) {
      commit("setTeamMembers", data.data);
    }
  },
  /**
   * 移除协作项目中成员
   * @param {type}   userId  被移除用户id，多个用户用,隔开
   * @param {type}   id 	所属项目id
   */
  async removeCooperator({ commit }, params) {
    const { data } = await axios.post(
      "/api/user/account/cooperation/removeFromDraft",
      params
    );
    commit("setRemoveCooperatorCode", data);
  },

  //刷新版本记录列表
  async refreshHistotyVersionList({ commit }) {
    let { data } = await axios.get(
      "/api/user/account/cooperation/historyVersion",
      {
        params: {
          id: state.cooperationDraft.shareDraftId,
        }
      }
    );
    if (data.code === 200) {
      commit("setHistoryVersionList", data.data);
    }
    //console.log("refreshHistotyVersionList", state.historyVersionList);
    return data;
  },


  //创建一条新的版本记录
  async createNewHistotyVersion({ commit }) {
    let params = {
      id: state.cooperationDraft.shareDraftId,
      data: state.cooperationDraft.data,
      title: state.cooperationDraft.title,
      duration: state.cooperationDraft.duration,
      thumbnailUrl: state.cooperationDraft.thumbnailUrl,
      screen: state.cooperationDraft.thumbnailUrl,
      isUpdate: 1
    }
    let { data } = await axios.post(
      "/api/user/account/cooperation/templateU",
      params
    );
    if (data.code === 200) {
      await this.dispatch('refreshHistotyVersionList');
    }
    return data;
  },

  //加载一条旧的版本记录
  async reloadHistotyVersion({ commit }, id) {
    let { data } = await axios.post(
      "/api/user/account/cooperation/renewDraft",
      { id }
    );
    return data;
  },

  //删除一条版本记录
  async deleteHistotyVersion({ commit }, id) {
    let { data } = await axios.post(
      "/api/user/account/cooperation/deleteDraftVersion",
      { id }
    );
    await this.dispatch('refreshHistotyVersionList');
    return data;
  },

  //更改描述
  async editHistotyVersion({ commit }, {id, description}) {
    let { data } = await axios.post(
      "/api/user/account/cooperation/updateDescription",
      { id, description }
    );
    return data;
  },

};

const mutations = {
  setTeamCooTempList(state, action) {
    state.teamCooTempList.data = action.data.map(item => {
      if (item.shareDarftVersion.userInfo.headImgUrl === null) {
        item.shareDarftVersion.userInfo.headImgUrl = ["null"];
      } else {
        item.shareDarftVersion.userInfo.headImgUrl = item.shareDarftVersion.userInfo.headImgUrl.split(",");
      }
      item.shareDarftVersion.userInfo.nickname = item.shareDarftVersion.userInfo.nickname.split(",");
      item.shareDarftVersion.userInfo.userId = item.shareDarftVersion.userInfo.userId.split(",");
      return item;
    });
    state.teamCooTempList.total = action.total;
  },
  updateTempListFetching(state, action) {
    state.teamCooTempList.fetching = action;
  },
  setInviteCode(state, action) {
    state.inviteCode = action;
  },
  setJoinCooDraftState(state, action) {
    state.joinCooDraftStateInfo = action;
  },
  setCopeTemplateInfo(state, action) {
    state.copeTemplateInfo = action;
  },
  setTeamMembers(state, action) {
    state.teamMembers = action;
  },
  setRemoveCooperatorCode(state, action) {
    state.removeCooperatorStateInfo = action;
  },
  setCooperationType(state, data) {
    state.cooperationType = data;
  },
  setCooperationDraft(state, data) {
    state.cooperationDraft = data;
  },
  setHistoryVersionList(state, data) {
    //console.log('state.cooperationDraft',state.cooperationDraft)
    state.historyVersionList = data;
  },
  setShowCooperationBtn(state, data) {
    state.showCooperationBtn = data;
  },
  //cooperationDraftOwnerId
  setCooperationDraftOwnerId(state, data) {
    state.cooperationDraftOwnerId = data;
  },
  setPrivateDraft (state, flag) {
    state.privateDraft = flag;
  }
};

//moduleName -> cooperation
export default {
  //namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/cooperation.js